import { H3, Breadcrumbs } from '../../../../AbstractElements';
import { BillingDetails } from '../../../../Constant';
import ProductPlaceOrder from './ProductPlaceOrder';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import AddressShipping from './AddressShipping';
import { getClientUrlDataToken, postDataWithToken } from '../../../../Utils/restUtils';
import { getCart, guestPaymentConfirm, guestPaymentRequest } from '../../../../CommonUrl';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const CheckOutContain = () => {
    const location = useLocation();
    const authState = useSelector((state) => state.auth);
    const checkoutDetails = location.state?.checkoutDetails;
    const amountTotal = location.state?.total;
    const cartId= location.state?.cartIds;
    const [shippingMethod, setShippingMethod] = useState({ type: '', amount: 0 });
    const [apiResponse, setapiResponse] = useState(null);
    const [shippingAddressId, setShippingAddressId] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [discountAmount, setDiscountAmount] = useState(0);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        const response = await getClientUrlDataToken(getCart);
        setapiResponse(response?.data);
    }

    const continueInvoice = async () => {
        if (shippingAddressId === '') {
            toast.error('Shipping Address required')
        } else {
            const finalAmount = (
                Number(amountTotal) +
                Number(shippingMethod?.amount) -
                Number(discountAmount)
            ).toFixed(2);

            const postData = {
                cart_ids: cartId, order_discount: discountAmount, coupon_code: couponCode, shipping_address: shippingAddressId,
                payment_method: 'gateway', delivery_type: shippingMethod?.type,
                request_from: "web",
                customer_id: authState?.role,
                amount: finalAmount,
                gateway: "cybersource",
                type: 'purchase_order',
            };
            const paymentConfirm = await postDataWithToken(guestPaymentRequest, postData);
            if (paymentConfirm?.status === 200) {

                if (paymentConfirm?.data?.status === true) {
                    const response = await getClientUrlDataToken(
                        guestPaymentConfirm + paymentConfirm?.data?.data?.order_request_id
                    );
                    document.open();
                    document.write(response);
                    document.close();
                } else {
                    toast.error(paymentConfirm?.data?.message);
                }
            } else {
                toast.error('Something went wrong');
            }
        }
    };

    return (
        <Fragment>
            <Breadcrumbs parent="Ecommerce" title="Checkout" mainTitle="Checkout" />
            <Container fluid={true}>
                <Row style={{ marginTop: '80px' }}>
                    <Col>
                        <Card className="checkout">
                            <CardHeader className="pb-0">
                                <H3>{BillingDetails}</H3>
                            </CardHeader>
                            <CardBody>
                                <Row style={{ padding: '30px' }}>
                                    <AddressShipping details={checkoutDetails} setShippingMethod={setShippingMethod} shippingMethod={shippingMethod}
                                        setShippingAddressId={setShippingAddressId} continueInvoice={continueInvoice}
                                        shippingAddressId={shippingAddressId} />
                                    <ProductPlaceOrder total={amountTotal} delivery={shippingMethod} product={apiResponse}
                                        setCouponCode={setCouponCode} setDiscountAmount={setDiscountAmount}
                                        couponCode={couponCode} />
                                </Row >
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
export default CheckOutContain;